export default __webpack_public_path__ + "static/media/skype.22cb1580.svg";